import React, { useMemo, useCallback, FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';

import { ReactComponent as PublicIcon } from '../../../icons/public.svg';
import MainFooterButton from '../../buttons/MainFooterButton';

import getLanguageCode from '../../../utils/language/getLanguageCode';

export interface FooterLanguageButtonProps {
  /**
 * Callback triggered when the language button is clicked.
 *
 * @param {string} nextLanguage The next language code
 */
  onLanguageChange: (language: 'fr' | 'en') => void;
  /** Removes the language button */
}

const FooterLanguageButton: FC<FooterLanguageButtonProps> = ({ onLanguageChange }) => {
  const { language } = useTranslation();

  const isCurrentLanguageFrench = useMemo(() => getLanguageCode(language) === 'fr', [language]);
  const nextLanguage = useMemo(() => isCurrentLanguageFrench ? 'en' : 'fr', [isCurrentLanguageFrench]);
  const nextLanguageText = useMemo(() => isCurrentLanguageFrench ? 'English' : 'Français', [isCurrentLanguageFrench]);

  const handleLanguageChange = useCallback(() => {
    onLanguageChange(nextLanguage);
  }, [nextLanguage, onLanguageChange]);

  return (
    <MainFooterButton
      onClick={handleLanguageChange}
      RightIcon={PublicIcon}
      data-testid="FooterLinksLanguageButton"
    >
      {nextLanguageText}
    </MainFooterButton>
  );
};

export default FooterLanguageButton;
